import { Box } from '@mui/material';

import { Proposal } from 'entities/Proposal/model/types/ProposalSchema';
import { SupplierBadge, SupplierBadgeItem } from 'shared/ui/SupplierBadge';
import { DynamicTooltip } from 'shared/ui/Tooltip';

import { SupplierStatusIcon } from './SupplierStatusIcon';
import { SuppliersStatusList } from './SuppliersStatusList';

import { useProposalsStatus } from '../lib/hooks/useProposalsStatus';

interface SupplierBadgeWithTooltipProps {
    proposals: SupplierBadgeItem[];
    fullProposals: Proposal[];
}

export const SupplierBadgeWithTooltip = ({
    proposals,
    fullProposals,
}: SupplierBadgeWithTooltipProps) => {
    const aggregateStatus = useProposalsStatus(fullProposals);

    if (proposals.length === 0) return null;

    return (
        <DynamicTooltip
            trigger="hover"
            interactive
            placement="top-start"
            content={
                <Box sx={{ minWidth: 280 }}>
                    <SuppliersStatusList proposals={fullProposals} />
                </Box>
            }
        >
            <Box
                sx={{
                    cursor: 'pointer',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                }}
            >
                <SupplierBadge proposals={proposals} />
                {aggregateStatus && (
                    <SupplierStatusIcon status={aggregateStatus} />
                )}
            </Box>
        </DynamicTooltip>
    );
};
